import React from 'react';
import { useSearchParams } from 'react-router-dom';
import LoginForm from '../auth/LoginForm';
import { safeRedirect } from '../../utils/redirectUtils';

// ?redirect= is the admin page the guard sent the person away from (see RoleRoute).
const AdminLogin = () => {
  const [searchParams] = useSearchParams();
  return (
    <LoginForm
      title="Admin Login"
      subtitle="Enter your credentials to access the admin dashboard"
      redirectTo={safeRedirect(searchParams.get('redirect')) || '/admin/dashboard'}
    />
  );
};

export default AdminLogin;
